import { FunctionComponent, useState } from 'react';
import styles from "./Newsletters.module.css";
import cn from 'classnames';
// import {Image} from 'react-bootstrap';
import SidebarLayout from '../../../../../component/common/Layout/SidebarLayout/SidebarLayout';
import TextHeader from '../../../../../component/common/TextHeader/TextHeader';
// import CustomButton, { ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
// import { ASSESTS } from '../../../../../constant/assest';
import SearchInput from '../../../../../component/common/SearchInput/SearchInput';
import NewsletterSubscribersTable from './component/NewslettersTable/NewsletterSubscribersTable';
// import NewslettersTemplateGallery from '../../../../../component/UI/NewslettersTemplateGallery/NewslettersTemplateGallery';
// import NewsletterTemplatesPreview from '../../../../../component/UI/NewsletterTemplatesPreview/NewsletterTemplatesPreview';
// import CreateNewsletterTemplates from '../../../../../component/UI/CreateNewsletterTemplates/CreateNewsletterTemplates';
import { useDebounce } from '../../../../../hooks/useDebounce';

const Newsletters: FunctionComponent = () => {

    // const [showCreateTemplate, setShowCreateTemplate] = useState<boolean>(false);
    // const [showPreviewTemplate, setShowPreviewTemplate] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm.trim(), 500);

    // const createNewsLetterRef = useRef<HTMLDivElement | null>(null);
    // const handleScrollToUpload = () => {
    //     setShowCreateTemplate(true);
    //     if (createNewsLetterRef.current) {
    //         createNewsLetterRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }
    // };

    return (
        <SidebarLayout>
            <div className={cn(styles.newslettersPage)}>
                <TextHeader 
                    // title={'Newsletter Management'} 
                    title={'Newsletter Subscribers'} 
                    // summary={"Create, manage, and send newsletters to your users"}
                    className='mb-4'
                />
                {/* <div className={styles.newslettersHeader}>
                    <div className={styles.textWrapper}>
                        <div className={styles.header}>Newsletter Templates</div>
                        <div className={styles.text}>Select a template or Create a new one</div>
                    </div>
                    <CustomButton 
                        className={styles.addNewContentBtn}
                        btnType={ButtonType.GREEN}
                        onClick={handleScrollToUpload}
                    >
                        <Image src={ASSESTS.ADD} alt={'New Template'} /> New Template
                    </CustomButton>
                </div> */}
                {/* <div className={styles.newslettersSlider}>
                    <NewslettersTemplateGallery 
                        onItemClick={() => {setShowPreviewTemplate(true);}}
                    />
                </div>
                {showPreviewTemplate && <NewsletterTemplatesPreview />}
                <div ref={createNewsLetterRef} className={styles.createNewsletter}>
                    {showCreateTemplate && <CreateNewsletterTemplates />}
                </div> */}

                <div className={cn(styles.newslettersBottomRow)}>
                    <div className={styles.newslettersBottomHeader}>
                        {/* <div className={styles.bottomTitle}>Newsletter  Recipients</div> */}
                        <div className={styles.bottomTitle}>Newsletter  Subscribers</div>
                        <SearchInput 
                            placeholder='Search by Email...' 
                            className={cn(styles.newslettersSearch, 'mb-0')}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className={styles.tableArea}>
                        <NewsletterSubscribersTable searchTerm={debouncedSearchTerm} />
                    </div>
                </div>
            </div>
        </SidebarLayout>
    );
};

export default Newsletters;